var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7832 5.22259C17.0745 5.51708 17.0719 5.99195 16.7774 6.28323L8.18366 14.7832C7.89145 15.0723 7.42105 15.0723 7.12884 14.7832L3.22259 10.9196C2.92809 10.6283 2.92549 10.1534 3.21677 9.85895C3.50805 9.56446 3.98292 9.56185 4.27741 9.85313L7.65625 13.1951L15.7226 5.21677C16.0171 4.92549 16.4919 4.92809 16.7832 5.22259Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "9edacb0fb87d25f6d45514a82351ca52.svg";
export { ForwardRef as ReactComponent };